import { render, staticRenderFns } from "./HistoryBio.vue?vue&type=template&id=b211ef96&scoped=true"
import script from "./HistoryBio.vue?vue&type=script&lang=js"
export * from "./HistoryBio.vue?vue&type=script&lang=js"
import style0 from "./HistoryBio.vue?vue&type=style&index=0&id=b211ef96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b211ef96",
  null
  
)

export default component.exports